import { defineComponent as _defineComponent } from 'vue'
import Platform from "@/config/platform";
import router from "@/router";
import { Toast, Dialog } from "vant";
import { ref } from "vue";
import { Storage } from "@/uitls/Storage";

export default /*#__PURE__*/_defineComponent({
  name: 'Blank',
  setup(__props, { expose }) {
  expose();

const show = ref(true)
const ok = () => {
    Storage.set("xieyi", '1111')
    router.replace('/')
}
const getxy = () => {
    if (Platform.address == "") {
        return  "https://jk.jktgedc.com/download/serviceAgreement_tha.html"
    }
    return Platform.address + "download/serviceAgreement_tha.html"
}

const __returned__ = { show, ok, getxy }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})